module.exports = __webpack_public_path__ + "img/163-Chêne Doré - Sherwood G.jpg";